import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './yes-no-dialog.component.html',
  styleUrls: ['./yes-no-dialog.component.scss']
})
export class YesNoDialogComponent implements OnInit {

  public title: string;
  public message: string;
  public disableMe: boolean;
  public showDisableMe: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    // tslint:disable-next-line: max-line-length
    private data: { Message: string, Title: string, Result: boolean, DisableMe: boolean, ShowDisableMe: boolean },
    private mdDialogRef: MatDialogRef<YesNoDialogComponent>,
  ) {
    this.title = '';
    this.message = '';
    this.disableMe = false;
    this.showDisableMe = true;
  }

  ngOnInit() {
    this.title = this.data.Title;
    this.message = this.data.Message;
    this.disableMe = this.data.DisableMe;
    this.showDisableMe = this.data.ShowDisableMe;
  }

  public closeDialog(res: boolean) {
    this.data.Result = res;
    this.data.DisableMe = this.disableMe;
    this.mdDialogRef.close(this.data);
  }
}
